import ItemImageCard from './items/ItemImageCard'
import ItemTextPlain from './items/ItemTextPlain'

const itemDisplayModes = {
  ItemImageCard: ItemImageCard,
  ItemTextPlain: ItemTextPlain,
}

const itemTypeByDisplayMode = ( item ) => {
  let component

  component = itemDisplayModes[item.display_mode]

  if (!component) {
    return ItemTextPlain
  }

  return component
}

export {
  itemDisplayModes,
  itemTypeByDisplayMode
}
